/* global window, XMLHttpRequest, XDomainRequest */
/* eslint-disable complexity */
'use strict';

import {ieVersion, isString} from './utils';

const mimeTypes = {
    json: 'application/json',
    html: 'text/html'
};
const responseTypes = {
    json: 'json',
    html: 'text'
};

export function getHTML(url, cb) {
    doXhr({url, dataType: 'html'}, cb);
}

export function getJSON(url, cb) {
    doXhr({url, dataType: 'json'}, cb);
}

function doXhr(config, cb) {
    const useXDomainRequest = ieVersion <= 9 && window.XDomainRequest;
    // IE9 must use XDomainRequest for cors requests and must on the same protocol
    const xhr = new (useXDomainRequest ? XDomainRequest : XMLHttpRequest)();
    const responseType = responseTypes[config.dataType] || '';

    // set an empty handler for 'onprogress' so requests don't get aborted (IE9)
    xhr.onprogress = () => {};
    xhr.onerror = xhr.ontimeout = xhr.onabort = (e) => {
        cb(e);
    };
    xhr.onload = () => {
        // normalize XDomainRequest
        if (useXDomainRequest) {
            xhr.status = 200;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
            cb(new Error(`status code ${xhr.status}`));
            return;
        }

        let data;

        if (responseType === '' || responseType === 'text') {
            data = xhr.responseText;
        } else if (responseType === 'json') {
            data = xhr.response;

            if (!data && useXDomainRequest) {
                data = xhr.responseText;
            }

            if (isString(data)) {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    cb(e);
                    return;
                }
            }
        }

        cb(null, data);
    };
    xhr.open('GET', config.url, true);
    xhr.responseType = responseType;
    xhr.withCredentials = true;
    if (xhr.setRequestHeader) {
        xhr.setRequestHeader('Accept', mimeTypes[config.dataType]);
    }
    xhr.send(null);
}
